"use client";
import { useState } from "react";
import Twemoji from "react-twemoji";
import { config } from "./config";
import Join from "./Join";
import MultipleChoice from "./MultipleChoice";
import PercentSlider from "./PercentSlider";
import { submitResponse } from "./services";
import "./styles/App.scss";
import { Landlord, Question, qs, selectionQuestions } from "./SurveyQuestions";

function Survey({
  landlordList,
  hideSurvey,
  address,
  propertyId,
}: {
  landlordList: Landlord[];
  hideSurvey: (showJoin: boolean) => void;
  address: string;
  propertyId: string;
}) {
  const [questions]: [Question[], any] = useState(qs);
  const [answersSelected, setAnswersSelected] = useState(
    {} as { [key: string]: number }
  );
  const [reviewText, setReviewText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showJoin, setShowJoin] = useState(false);
  const [hideJoin, setHideJoin] = useState(false);

  function submit() {
    setIsLoading(true);

    // const answers = Object.keys(answersSelected).reduce((agg, curr) => {
    //   const questionId = Number(curr);
    //   agg[questionId] = answersSelected[questionId];
    //   return agg;
    // }, [] as number[]);

    // const answer = answers[qs.findIndex((q) => q.tenantUnion)];
    // if (answer === 0 || answer === 2) {
    // }

    submitResponse({
      sourceSystem: config.CITY,
      answersSelected,
      landlordList,
      reviewText,
      address,
      propertyId,
    }).then((result) => {
      console.log(result);
      setIsLoading(false);
      hideSurvey(hideJoin ? false : true);
    });
  }

  return (
    <div>
      <h3 className="survey-title">Leave a Review</h3>
      {questions.map(
        (q, questionIndex) =>
          !q.hidden && (
            <div className="question">
              {/* <p>
                {q.emoji} {q.text}
              </p> */}
              {q.type === "percent" ? (
                <PercentSlider
                  id={q.id}
                  text={q.text}
                  emoji={q.emoji}
                  statement={q.statement}
                  value={answersSelected[q.id]}
                  onChange={(val) =>
                    setAnswersSelected((prev) => {
                      const next = { ...prev };
                      if (val === null) {
                        delete next[q.id];
                      } else {
                        next[q.id] = val;
                      }
                      return next;
                    })
                  }
                />
              ) : (
                q.answers && (
                  <MultipleChoice
                    id={q.id}
                    text={q.text}
                    emoji={q.emoji}
                    statement={q.statement}
                    answers={q.answers}
                    value={answersSelected[q.id] ?? null}
                    onChange={(val) =>
                      setAnswersSelected((prev) => {
                        const next = { ...prev };
                        if (val === null) {
                          delete next[q.id];
                        } else {
                          next[q.id] = val;
                        }
                        if (q.tenantUnion) {
                          setShowJoin(val === 0 || val === 2);
                        }
                        return next;
                      })
                    }
                  />
                )
              )}
              {q.tenantUnion && !hideJoin && (
                <div
                  className={`tenant-union-join-answer ${
                    showJoin ? "grow-in" : "grow-out"
                  }`}
                >
                  <Join
                    addSkills={["organise-tenant-unions"]}
                    onJoin={() => {
                      setHideJoin(true);
                    }}
                    title={config.get("joinTitle")}
                    text={config.get("joinText")}
                    property_id={propertyId}
                  />
                </div>
              )}
            </div>
          )
      )}
      <p className="select-any-title">Select any that apply</p>

      <div className="selection-questions">
        {selectionQuestions.questions.map((q, i) => (
          <button
            key={`${i}-sq`}
            onClick={() => {
              const ans = { ...answersSelected };
              ans[q.id] = ans[q.id] === 1 ? 0 : 1;
              setAnswersSelected(ans);
            }}
            className={`selection-question ${
              answersSelected[q.id] === 1 ? "selection-selected" : ""
            }`}
          >
            <Twemoji options={{ className: "small-emoji" }}>{q.emoji}</Twemoji>{" "}
            {q.text}
          </button>
        ))}
      </div>
      <div className="question">
        <p>What else do you want people to know about this landlord?</p>
        <textarea
          name="Text1"
          cols={40}
          rows={5}
          maxLength={1000}
          placeholder="Text entered here will need to be approved before it appears on the site"
          onChange={(event) => {
            setReviewText(event.target.value);
          }}
        ></textarea>
        <span className="char-counter">{reviewText.length} / 1000</span>
      </div>
      {/* <div>
                (optional) leave your name and email if you want us to contact you
                <input type="email"></input>
            </div> */}
      <div className="submit-button-wrapper">
        <button
          className={"submit-button" + (isLoading ? " button--loading" : "")}
          disabled={
            (Object.keys(answersSelected).length === 0 && reviewText === "") ||
            isLoading
          }
          onClick={() => {
            submit();
          }}
        >
          <span className="button__text">SUBMIT</span>
        </button>
      </div>
    </div>
  );
}

export default Survey;
